import Header from '../components/header.js';
import WhiteThinLine from '../components/line.js';
import CheckIsMobile from '../components/mobile.js';

export default function Home()
{
    let isMobile = CheckIsMobile();

    const H1Style = {
        textAlign: "center",
        display:"flex", 
        paddingTop: isMobile ? "1.5rem" : "2.5rem", 
        paddingBottom: isMobile ? "1.5rem" : "2.5rem", 
        justifyContent:"center", 
        alignContent:"center", 
        padding: "20px", 
        color:"cyan"
    }

    let ThickCyanLineStyle = {
        borderWidth: "1.5px", 
        borderColor: "cyan", 
        width: isMobile ? "90%" : "70%",    
        marginLeft: "auto", 
        marginRight: "auto"
    }

    let ParagraphStyle = {
        lineHeight: 1.8, 
        color: "white", 
        fontSize: isMobile ? 20 : 22, 
        paddingLeft: isMobile ? 50 : 75,
        paddingRight: isMobile ? 25 : 0, 
        font: "large", 
        alignItems: "center", 
        justifyContent: "center"
    }

    let ImageStyle = { 
        backgroundImage: `url('https://amvco.com.au/wp-content/uploads/2021/05/banner-1400x779-2880w.jpg')`, 
        width: "100%", 
        height: isMobile ? "70vh" : "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }

    return (

        <div>
            <Header />
          
            {/* Hero Section */}
            <section style={ ImageStyle } />

            {/* Specialist Section - Not working*/}  
            <section style={H1Style}>
                <h1 style={{ alignContent: "center", fontSize : isMobile ? "1.5rem" : "2.5rem" }}>Australia's Custom Vision System Specialist</h1> <br/>
            </section>
            <hr style = { ThickCyanLineStyle } /> <br /> <br />

            {/* Paragraph Section */}
            <section style={ ParagraphStyle }>
                <p>Australian Machine Vision is an industry leader in vision system integration.</p>
                <p>We have deployed systems nationwide to Australia's leading industrial and manufacturing corporations.</p>
            </section>

            {/* Aim Section */}
            <section style={{lineHeight: 1.8, padding: "40px 75px", color: "white"}}>
                <h2 style={{ fontSize: isMobile ? "1.4rem" : "2.0rem" }}>We aim to:</h2>
                <ul style={{listStyleType: "disc", paddingLeft: "0", fontSize: isMobile ? "1.3rem" : "1.5rem" }}>
                <li>Apply the latest vision system technology</li>
                <li>Customise the system to suit the end user</li>
                <li>Provide the best price/performance solution</li>
                </ul>
            </section>

            <WhiteThinLine />

            {/* Support Section */}
            <section style={{ textAlign: "center", paddingTop: isMobile ? "1.5rem" : "2.5rem", paddingBottom: isMobile ? "1.5rem" : "2.5rem" }}>
                <h1 style={{color:"cyan", fontSize: isMobile ? "1.5rem" : "2.5rem"}}>Vision System Support</h1>
                <hr style={{ borderWidth: "1.5px", borderColor: "cyan", width: isMobile ? "50%" : "37%",          
                            marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} /> <br/> <br/>
                <p style={{lineHeight: 1.8, color:"white", fontSize: isMobile ? "1.3rem" : "1.5rem", paddingLeft: isMobile ? 50 : 75, paddingRight: isMobile ? 25 : 40}}>
                <b>Australian Machine Vision</b> provides onsite or remote support for vision system technologies
                like Halcon, Dalsa/Sherlock, Omron, Cognex, & Balluf.
                </p> <br/>
                <p style={{lineHeight: 1.8, color:"white", fontSize: isMobile ? 20 : 22, paddingLeft: isMobile ? 50 : 75, paddingRight: isMobile ? 25 : 0}}>Email: <b>amvsupport@amvco.com.au</b> | Support Line: <b>0499 990 117</b></p>
            </section>

            <WhiteThinLine />

            {/* Services Section */}
            <section style={{ textAlign: "center", paddingTop: "2.5rem", paddingBottom: "2.5rem" }}>
                <h1 style={{color:"cyan", fontSize: isMobile ? "1.5rem" : "2rem"}}>Find out more about our services today</h1> <br />
                <h2 style={{color: "cyan", fontSize: "1.875rem"}}>Call 0499 990 117 or 0418 535 729</h2> 
            </section>

            <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                              marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} />

            <br /> <br /> <br /> <br /> <br />

        </div>
      
      
      
    )
}
